'use strict';

function createRequestCache(staleMs) {
  const cache = new Map();
  const inFlight = new Map();
  let generation = 0;

  function get(key, loader, force) {
    const cached = cache.get(key);
    const isFresh = cached && Date.now() - cached.loadedAt < staleMs;
    if (!force && isFresh) return Promise.resolve(cached.data);
    if (inFlight.has(key)) return inFlight.get(key);

    const requestGeneration = generation;
    const request = Promise.resolve()
      .then(loader)
      .then((data) => {
        if (requestGeneration === generation) {
          cache.set(key, { data, loadedAt: Date.now() });
        }
        return data;
      })
      .finally(() => {
        if (inFlight.get(key) === request) inFlight.delete(key);
      });

    inFlight.set(key, request);
    return request;
  }

  function getStaleWhileRevalidate(key, loader) {
    const cached = cache.get(key);
    if (!cached) {
      return { data: null, revalidate: get(key, loader) };
    }

    const isStale = Date.now() - cached.loadedAt >= staleMs;
    return {
      data: cached.data,
      revalidate: isStale ? get(key, loader, true) : Promise.resolve(cached.data),
    };
  }

  function peek(key) {
    const cached = cache.get(key);
    return cached ? cached.data : null;
  }

  function clear() {
    generation += 1;
    cache.clear();
    inFlight.clear();
  }

  return { clear, get, getStaleWhileRevalidate, peek };
}

module.exports = { createRequestCache };
